import script from "./loading.vue?vue&type=script&setup=true&name=Loading&lang=js"
export * from "./loading.vue?vue&type=script&setup=true&name=Loading&lang=js"

import "./loading.vue?vue&type=style&index=0&id=56fbe57f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56fbe57f"]])

export default __exports__